export function normalizeTagForRegex(tag: string, regex?: RegExp): string {
  if (!regex) {
    return tag;
  }

  regex.lastIndex = 0;
  if (regex.test(tag)) {
    return tag;
  }

  const lowercased = tag.toLowerCase();
  if (lowercased !== tag) {
    regex.lastIndex = 0;
    if (regex.test(lowercased)) {
      return lowercased;
    }
  }

  return tag;
}
